export const SEND_DRAWING_SUCCESS = "send_drawing_success";
export const SEND_DRAWING_FAILED = "send_drawing_failed";
export const RESET_DRAWING_STATUS = "reset_drawing_status";
export const FETCH_IMAGES_SUCCESS = "fetch_images_success";
export const FETCH_IMAGES_FAILED = "fetch_images_failed";
export const APPROVE_IMAGES_SUCCESS = "approve_images_success";
export const APPROVE_IMAGES_FAILED = "approve_images_failed";
export const REJECT_IMAGE_SUCCESS = "reject_images_success";
export const REJECT_IMAGE_FAILED = "reject_images_failed";
export const UPLOAD_STATUS_TO_NULL = "upload_status_to_null";
export const USER_LOGIN_REQUEST = "user_login_request";
export const USER_SUCCESS_LOGIN = "user_succes_login";
export const USER_FAILED_LOGIN = "user_failed_login";
export const UPDATE_MAILCHIMP_SUCCESS = "update_mailchimp_success";
export const UPDATE_MAILCHIMP_FAILED = "update_mailchimp_failed";
export const FETCH_MAILCHIMP_MEMBER_SUCCESS = "fetch_mailchimp_member_success";
export const FETCH_MAILCHIMP_MEMBER_FAILED = "fetch_mailchimp_member_failed";
export const LOGOUT = "logout";
export const API_HOST_URL = "https://tuckandrose.family:5000";
// export const API_HOST_URL = "http://localhost:5000";



// WEBPACK FOOTER //
// ./src/actions/types.js